import { render, staticRenderFns } from "./jydcsjtj.vue?vue&type=template&id=03b84ccd&scoped=true"
import script from "./jydcsjtj.vue?vue&type=script&lang=js"
export * from "./jydcsjtj.vue?vue&type=script&lang=js"
import style0 from "./jydcsjtj.vue?vue&type=style&index=0&id=03b84ccd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!E:\\SAAS-QSX-JYJ\\WEB\\node_modules\\_vue-loader@15.11.1@vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b84ccd",
  null
  
)

export default component.exports